// Written in this round about way for babel-transform-imports
import matchPath from 'react-router/es/matchPath';

export default matchPath;


//////////////////
// WEBPACK FOOTER
// ../~/react-router-dom/es/matchPath.js
// module id = 1360
// module chunks = 0